import classNames from 'classnames';
import renderInlineItalic from 'lib/utils/renderInlineItalic';
import Image from 'components/shared/image';
import useIsMobile from 'hooks/utils/useIsMobile';
import SiteLink from 'components/shared/sitelink/sitelink';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './advice.module.scss';

const Advice = ({ data, locale }) => {
  const { adviceArticles, anchorId } = data;
  const isMobile = useIsMobile();

  return (
    <section id={anchorId}>
      <div className={styles.adviceArticles}>
        {adviceArticles.map((article, index) => (
          <AdviceArticleCard
            locale={locale}
            data={article}
            isMobile={isMobile}
            isDivider={index !== adviceArticles.length - 1}
          />
        ))}
      </div>
    </section>
  );
};

const AdviceArticleCard = ({ locale, data, isMobile, isDivider }) => {
  const router = useRouter();
  const { articleLink, headlineImage, title, titleFont, subtitle } = data;
  const titleClass = classNames(styles.articleTitle, titleFont !== 'Acumin Pro' && styles.octave);

  return (
    <div className={styles.articleWrapperSmall}>
      <div>
        <div className={styles.articleHeadlineImageSmall}>
          <Image
            src={headlineImage?.image}
            layout="responsive"
            loading="eager"
            priority
            sizes="(max-width: 899px) 100vw, 33vw"
          />
        </div>
        <h2 className={titleClass}>{renderInlineItalic(title)}</h2>
        <p className={styles.articleSubtitle}>{subtitle}</p>
        {articleLink && (
          <SiteLink
            locale={locale}
            href={addLocaleToHref(articleLink.slug, locale, router)}
            className={styles.readMoreButton}
            external={articleLink.externalLink}
          >
            {articleLink.title}
          </SiteLink>
        )}
        {isMobile && isDivider && <div className={styles.articleDivider} />}
      </div>
    </div>
  );
};

export default Advice;
